import type { UseHttp } from '~/api/interface'

export const fetchPageBanner: UseHttp = (params, option) => {
  return useHttp.post('/api/bannerApi/page', params, {
    ...option
  })
}

export const clientFetchPageBanner: UseHttp = (params, option) => {
  return useHttp.post('/api/bannerApi/page', params, option)
}
